import { Button, Menu, MenuGroup, MenuButton, MenuDivider, MenuList, MenuOptionGroup, Portal } from '@chakra-ui/react';
import React, { FC, useState, ChangeEvent } from 'react';
import { Group, Item, MenuProps } from './types';
import { MenuItem } from './menu-item';

export const DropdownMenu: FC<MenuProps> = ({
  colorScheme,
  disabled,
  menuButton,
  menuButtonText,
  menuButtonIcon,
  menuButtonRightIcon,
  groups = [],
  items = [],
  placement = 'bottom-start',
  isMenuItemOptions = false,
  variant,
  w,
  menuListWidth,
  usePortal,
  onOpen,
  'aria-label': ariaLabel,
}) => {
  const [subMenuSelections, setSubMenuSelections] = useState<string[]>([]);

  const checkboxChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    let updatedArr = [...subMenuSelections];
    if (!updatedArr.includes(value)) {
      updatedArr.push(value);
    } else {
      updatedArr = updatedArr.filter(item => item !== value);
    }
    setSubMenuSelections(updatedArr);
  };

  const menuItems = (items: Item[]) => {
    return items.map((item, index) => {
      const key = `${item.text}-${item.value}-${index}`;
      const count = item.items?.filter(item => item.value && subMenuSelections.includes(item.value)).length;
      return (
        <MenuItem
          key={key}
          item={item}
          isMenuItemOptions={isMenuItemOptions}
          setSubMenuSelections={setSubMenuSelections}
          checkboxChange={checkboxChange}
          selectionCount={count}
        ></MenuItem>
      );
    });
  };

  const menuGroups = (groups: Group[]) => {
    return groups.map((group, index) => {
      const key = `${group.groupTitle}-${index}`;
      if (isMenuItemOptions) {
        return (
          <div key={key}>
            <MenuOptionGroup
              key={key}
              title={group.groupTitle}
              type={group.menuGroupOptionType}
              defaultValue={group.defaultValue}
            >
              {menuItems(group.items)}
            </MenuOptionGroup>
            {!!group.hasDivider && <MenuDivider />}
          </div>
        );
      }
      return (
        <div key={key}>
          <MenuGroup title={group.groupTitle}>{menuItems(group.items)}</MenuGroup>
          {!!group.hasDivider && <MenuDivider />}
        </div>
      );
    });
  };
  /**
   * DOM
   */
  const MenuContent = (
    <MenuList w={menuListWidth} data-object-type="core-dropdown-menu-list" zIndex="var(--udl-zIndices-popover, 1500)">
      {!!items && menuItems(items)}
      {!!groups && menuGroups(groups)}
    </MenuList>
  );
  return (
    <Menu
      data-object-type="core-dropdown-menu"
      placement={placement}
      closeOnSelect={!isMenuItemOptions}
      onOpen={onOpen}
    >
      {menuButton || (
        <MenuButton
          as={Button}
          rightIcon={menuButtonRightIcon}
          data-object-type="core-dropdown-menu-button"
          variant={variant}
          w={w}
          isDisabled={disabled}
          colorScheme={colorScheme}
          aria-label={ariaLabel}
        >
          {!!menuButtonText && <>{menuButtonText}</>}
          {!!menuButtonIcon && <>{menuButtonIcon}</>}
        </MenuButton>
      )}
      {usePortal ? <Portal>{MenuContent}</Portal> : MenuContent}
    </Menu>
  );
};
